import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ILink, NcgLocationMapCategory, NgcApiLocation } from '@ncg/data';

import { expansionAnimation } from '../../../expansion-panel/expansion.animation';

@Component({
    selector: 'ncg-map-window-content',
    template: `
        <div class="location-marker" *ngIf="location">
            <div class="map-item__brands columns is-mobile is-variable is-1" *ngIf="isBrandLayout">
                <div class="column is-narrow map-item__brand-image" *ngFor="let brand of location.brands">
                    <ncg-logos [allowAllLogos]="true" [key]="brand" iconWidthSm="18" iconWidth="21" iconWidthLg="30" iconWidthXl="35"></ncg-logos>
                </div>
            </div>
            <h5 class="map-item__content--name">{{ location.name }}</h5>
            <h6 *ngIf="!isBrandLayout" class="map-item__content--name map-item__content--name--official">{{ location.distributor?.name }}</h6>
            <div class="map-item__box" *ngIf="location.phone || location.externalDealerSite">
                <p *ngIf="location.phone">
                    <span class="map-phone__title">{{ 'map.phone_label' | translate }} </span>
                    <a class="map-phone__number" [href]="'tel:' + location.phone">{{ location.phone }}</a>
                </p>
                <p *ngIf="location.externalDealerSite">
                    <a [href]="location.externalDealerSite" [attr.title]="location.externalDealerSite" target="_blank">
                        <ncg-text-sprite-icon [iconUrl]="'assets/images/sprite.svg#external-link'">{{
                            'map.dealer_link' | translate
                        }}</ncg-text-sprite-icon>
                    </a>
                </p>
            </div>

            <ncg-map-location-info-contact
                [location]="location"
                [currentCategory]="currentCategory"
                [serviceLink]="serviceLink"
                [testDriveLink]="testDriveLink"
                [hideServiceButton]="hideServiceButton"
                [hideTestDriveButton]="hideTestDriveButton"
                [contactLink]="contactLink"
                [hideContactButton]="hideContactButton"
                [isBrandLayout]="isBrandLayout"
                [openingHoursLink]="openingHoursLink"></ncg-map-location-info-contact>
        </div>
    `,
    animations: [expansionAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MapWindowContentComponent {
    @Input()
    public location?: NgcApiLocation;
    @Input()
    public serviceLink?: ILink;
    @Input()
    public testDriveLink?: ILink;
    @Input()
    public hideServiceButton?: boolean;
    @Input()
    public hideTestDriveButton?: boolean;
    @Input()
    public contactLink?: ILink;
    @Input()
    public hideContactButton?: boolean;
    @Input()
    public currentCategory?: NcgLocationMapCategory;
    @Input()
    public isBrandLayout?: boolean;
    @Input()
    public directionsUrl?: string;
    @Input()
    public openingHoursLink?: ILink;
}
